import styled from '@emotion/styled'

import { COLORS } from '@/styles/colors'

export const RadioOuter = styled('span', {
  shouldForwardProp: (prop) => prop !== 'selected',
})<{ selected: boolean }>`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 9999px;
  ${({ selected }) =>
    selected
      ? `background-color: ${COLORS.brand};`
      : `border: 2px solid ${COLORS.strokeInput}; background-color: ${COLORS.bgWhite};`}
`

export const RadioInner = styled.span`
  width: 10px;
  height: 10px;
  border-radius: 9999px;
  background-color: ${COLORS.bgWhite};
`
